import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@/utils/antdIcon";
import { IconArrowLeft } from "@/components/icon";
import styles from "./index.module.less";
export const Btn = ({ loading, onClick, text, disabled }: any) => {
  const loadingComp = (
    <Spin
      style={{
        display: loading ? "block" : "none"
      }}
      indicator={<LoadingOutlined style={{ fontSize: 16, color: "white" }} spin />}
    />
  );
  return (
    <div
      role="button"
      tabIndex={0}
      onKeyDown={() => {}}
      onClick={disabled ? () => {} : onClick}
      className={styles.btn}
      style={
        !disabled
          ? {
              opacity: 1,
              cursor: "pointer"
            }
          : {
            background: "#BABFC5"
          }
      }
    >
      <div>{loadingComp}</div>
      <div
        style={{
          margin: 12,
          fontSize: 16,
          color: "rgb(255, 255, 255)"
        }}
      >
        {text}
      </div>
    </div>
  );
};

export const BackNav = ({
  clickHandle,
  title,
  desc,
  subtitle,
  icon,
  mobile,
  titleIcon
}: {
  clickHandle: () => void;
  subtitle?: string;
  desc?: string;
  title: string;
  icon?: any;
  mobile?: string;
  titleIcon?: any
}) => {
  return (
    <>
      <div
        style={{
          position: "absolute",
          top: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start"
        }}
        className={styles['hover-color']}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer"
          }}
          onClick={() => {
            setTimeout(() => {
              clickHandle();
            }, 0);
          }}
        >
          {icon || IconArrowLeft}
          <span
            style={{
              marginLeft: 5,
              verticalAlign: "middle",
              fontSize: 14
            }}
          >
            {title}
          </span>
        </div>
      </div>
      <div className={styles.inputCodeTitle} style={{marginTop: 40}}>
        {titleIcon}
        {subtitle}
      </div>
      
      <p
        className={styles.inputTip}
      >
        <span style={{color: "#1B1B1B", fontWeight: 500}}>{mobile}</span>
        {desc}
      </p>
    </>
  );
};
